import React, { useState } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import "bootstrap/dist/css/bootstrap.min.css";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import EditIcon from '@material-ui/icons/Edit';
import cookie from 'react-cookies';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import db from "./firebase";
function MyVerticallyCenteredModal(props) {
  const [note, setNote] = useState({
    title: props.title,
    content: props.content
  });
  const userid = cookie.load("userid");
  function handleChange(event) {
    const { name, value } = event.target;
    setNote(prevNote => {
      return {
        ...prevNote,
        [name]: value
      };
    });
  }
  function submitNote(event) {
    db.collection("users")
      .where('userid', '==', userid)
      .onSnapshot((snapshot) => {
        snapshot.docs.map((doc) => {
          db.collection('users')
            .doc(doc.id)
            .collection('Notes')
            .doc(props.id)
            .update({
              title: note.title,
              content: note.content
            })
            return 0;
        });
      })
    event.preventDefault();
    props.onHide();
  }
  function close() {
    props.onHide();
    
  }
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Title id="contained-modal-title-vcenter">
        {/* <input
          name="title"
          onChange={handleChange}
          value={note.title}
          placeholder="Enter Title here"
          className="title-edit"
        /> */}
        <div
        className="title-edit">
        {note.title} 
        </div>

      </Modal.Title>
      <Modal.Body >
        {/* <textarea
          name="content"
          onChange={handleChange}
          value={note.content}
          className="text-area"
          placeholder="Enter Note here"
        /> */}
         <div 
        className="text-area"
        >
        {note.content}
        </div>


      </Modal.Body>
      <div className="buttons-pop">
      <Button className="btn btn-secondary close" variant="primary" onClick={close}>
        Close
      </Button>
      {/* <Button className="btn btn-secondary save-changes" variant="primary" onClick={submitNote}>
        Save Changes
      </Button> */}
      </div>
    </Modal>
  );
}
function Note(props) {
  const [modalShow, setModalShow] = React.useState(false);
  function active() {
    setModalShow(true);
  }
  function deactive() {
    setModalShow(false);
  }
  return (
    <div  className="note">
     <button onClick={() => { props.deletenote(props.id) }} className="del-icon" title="Delete">
        <DeleteIcon />
      </button>
      <Button className="btn btn-secondary edit-icon" variant="primary" onClick={active} title="View">
        <RemoveRedEyeIcon className="edit-icon-center" />
      </Button>
      <div onClick={active}>
      <h1>{props.title}</h1>
      <p >{props.content}</p>
      </div>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={deactive}
        title={props.title}
        content={props.content}
        id={props.id}
      />
    </div>
  );
}

export default Note;
